module.exports = __webpack_public_path__ + "static/mtmeager1-7a6d2addbfec2592579c9b066d958e37.jpg";